import React, { useEffect, useState } from "react";
import axios from "axios";
import { BACKEND } from "../config/configEnvs";
import { FaFileExcel, FaFilter, FaInfoCircle, FaSpinner, FaTimes, FaUserEdit } from "react-icons/fa";
import { Button, Pagination } from "@mui/material";
import SearchIcon from '@mui/icons-material/Search';
import { toast } from "react-toastify";
import ItemRowAfiliacionClientes from "../components/afiliacionClientes/ItemRowAfiliacionClientes";
import FilterAfiliacionClientesDialog from "../components/dialogs/FilterAfiliacionClientesDialog";
import { ExportarSeleccionExcel } from "../utils/automateFuncions/ExportarColeccionExcel";
import { useSelector } from "react-redux";


const AfiliacionClientes = () => {

  const user = useSelector((state) => state.auth.user)
  const isSuperAdmin = user.area.toUpperCase() === "ADMINISTRACION" && (user.puesto.toUpperCase() === "GERENTE GENERAL" || user.area.toUpperCase() === "JEFE DE PROYECTOS")

  const [headersTableActive, setHeadersTableActive] = useState([]);
  const [openFilter, setOpenFilter] = useState(false);
  

  const [page, setPage] = useState(1)
  const [limit, setLimit] = useState(50)
  const [sorting, setSorting] = useState("desc")

  const [totalDocs, setTotalDocs] = useState(0)
  const [totalPages, setTotalPages] = useState(0)
  const [brandName, setBrandName] = useState("")
  const [clients, setClients] = useState([])
  const [activeAgency, setActiveAgency] = useState(false)

  const [loadingStatus, setLoadingStatus] = useState(false)

  const handleResetSearch = () => { // Resetea la búsqueda
    setBrandName(""); // Cambiar el estado
  };

  const handlePageChange = (event, value) => { // Cambiar la página
    setPage(value)
  }

  const getClients = async () => {
    try {
      setLoadingStatus(true)

      let url = `${BACKEND}/api/getClientsByCriteria/getClientsByPayments?page=${page}&limit=${limit}`

      if (brandName) {
        url += `&brandName=${brandName}`
      }

      if (sorting !== "") {
        url += `&sorting=${sorting}`
      }

      if (activeAgency) {
        url += `&activeAgency=${activeAgency}`
      }

      const response = await axios.get(url)

      setClients(response.data.clientsWithData)
      setTotalDocs(response.data.totalDocs)
      setTotalPages(response.data.totalPages)

    } catch (e) {
      toast.error("Error: " + e)
    } finally {
      setLoadingStatus(false)
    }
  }

  const ExportToExcel = async () => {
    try {
      const response = await axios.get(`${BACKEND}/api/getClientsByCriteria/getClientsByPayments?limit=10000`)
      const data = response.data.clientsWithData
      ExportarSeleccionExcel(data, "Afiliación clientes")
    } catch (e) {
      toast.error("Error: " + e)
    }
  }

  const handleSearchClients = () => { // Buscamos clientes y colocamos página 1
    setPage(1)
    getClients()
  }

  useEffect(() => {
    getClients()
  }, [page, limit, sorting, activeAgency])

  const headers = [
    { id: 1, name: "Estado", show: true },
    { id: 2, name: "ID Cliente", show: true },
    { id: 3, name: "Razon Social", show: true },
    { id: 4, name: "Compras totales", show: true },
    { id: 5, name: "Venden", show: true },
    { id: 30, name: "Ticket del producto", show: true },
    { id: 6, name: "Fecha de registro", show: true },
    { id: 7, name: "Servicios adquiridos", show: true },
    { id: 8, name: "ID Cotizaciones", show: true },
    { id: 9, name: "Última fecha venta", show: true },
    { id: 10, name: "Ruc", show: true },
    { id: 11, name: "Nombre comercial", show: true },
    { id: 12, name: "Pais", show: true },
    { id: 13, name: "Dirección", show: true },
    { id: 14, name: "Fecha aniversario", show: true },
    { id: 15, name: "Dias para aniversario", show: true },
    { id: 16, name: "N° Empleados", show: true },
    { id: 17, name: "Rubro", show: true },
    { id: 18, name: "Nicho", show: true },
    { id: 19, name: "Ingresos anuales", show: true },
    { id: 20, name: "Nombre gerente", show: true },
    { id: 21, name: "Cumpleaños gerente", show: true },
    { id: 22, name: "Dias para cumpleaños gerente", show: true },
    { id: 23, name: "Teléfono gerente", show: true },
    { id: 24, name: "Correo electrónico gerente", show: true },
    { id: 25, name: "Encargado de proyectos", show: true },
    { id: 26, name: "Correo electrónico", show: true },
    { id: 27, name: "Teléfono", show: true },
    { id: 28, name: "Fecha cumpleaños ", show: true },
    { id: 29, name: "Puesto de trabajo", show: true },
  ];

  useEffect(() => {
    const localActiveHeaders =
      JSON.parse(localStorage.getItem("activeTableColsAfiliacionClientes1")) ||
      [];
    if (localActiveHeaders.length > 0) {
      setHeadersTableActive(localActiveHeaders);
    } else {
      setHeadersTableActive(headers);
    }
  }, []);

  useEffect(() => {
    if (headersTableActive.length > 0) {
      localStorage.setItem(
        "activeTableColsAfiliacionClientes",
        JSON.stringify(headersTableActive)
      );
    }
  }, [headersTableActive]);

  return (
    <div className="flex flex-col h-screen w-full">

      <FilterAfiliacionClientesDialog
        activeCols={headersTableActive}
        setActiveCols={setHeadersTableActive}
        open={openFilter}
        setOpen={setOpenFilter}
      />

      {/* NavBar */}
      <div className="flex flex-row px-6 py-2 w-full bg-gray-100 flex flex-row justify-between mb-1 items-center">
        <div className="flex flex-row w-full items-center gap-4 justify-between">
          <div className="flex items-center gap-4 py-4">
            <FaUserEdit className="text-zinc-700 text-2xl" />
            <h2 className="text-2xl font-bold text-zinc-700">Afiliación clientes</h2>
          </div>

          <div className="flex flex-row gap-4 items-center justify-center">

            {isSuperAdmin && (
              <Button
                onClick={ExportToExcel} 
                variant="contained" 
                sx={{
                  fontSize: "12px",
                  fontWeight: "bold",
                  fontFamily: "poppins",
                  padding: "4px 24px",
                  backgroundColor: "#2e7d32",
                  transition: "all 0.3s ease",
                  textTransform: "none",
                  borderRadius: "8px",
                  minWidth: "180px",
                  maxWidth: "300px",
                  '&:hover': {
                    backgroundColor: "#1b5e20",
                  }
                }}
                endIcon={<FaFileExcel size={14} className="text-white"/>}
              >
                <span style={{ 
                  whiteSpace: "nowrap", 
                  overflow: "hidden", 
                  textOverflow: "ellipsis",
                  maxWidth: "300px"
                }}>
                  Exportar a Excel
                </span>
              </Button>
            )}

            <div className="flex flex-row text-xs text-gray-700 items-center justify-center gap-4">
              <span>Límite:</span>
              <select
                value={limit}
                onChange={(e) => setLimit(e.target.value)}
                className="text-gray-700 hover:cursor-pointer text-xs bg-white border border-gray-300 rounded-lg shadow focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent py-[6px] pr-10"
              >
                <option value="10">10</option>
                <option value="20">20</option>
                <option value="30">30</option>
                <option value="40">40</option>
                <option value="50">50</option>
              </select>
            </div>

            <div className="relative w-full">
              <input
                type="text"
                placeholder="Buscar marca"
                className="w-[16rem] text-xs text-gray-700 bg-white border border-gray-300 rounded-lg shadow focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent py-[6px] pr-10"
                value={brandName}
                onChange={(e) => setBrandName(e.target.value)}
              />
              {brandName && (
                <FaTimes
                  onClick={() => handleResetSearch()}
                  className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-500 hover:text-gray-700 cursor-pointer"
                />
              )}
            </div>

            <div>
              <Button
                variant="contained"
                endIcon={<SearchIcon />}
                sx={{
                  fontSize: "12px",
                  fontWeight: "bold",
                  fontFamily: "poppins",
                  padding: "4px 24px",
                  backgroundColor: "#ff6400",
                  transform: "all",
                  animationDuration: "1000",
                  textTransform: "none",
                  borderRadius: "8px",
                  '&:hover': {
                    backgroundColor: "#bb4a03",
                  }
                }}
                onClick={() => handleSearchClients()}
              >
                Buscar
              </Button>
            </div>

            <div className=" ">
              <button 
                className=" text-orange-600 bg-orange-500 bg-opacity-10 hover:bg-opacity-20 rounded-md p-3 " 
                type="button" 
                onClick={() => setOpenFilter(true)}
              >
                <FaFilter />
              </button>
            </div>

          </div>

        </div>
      </div>
      
      {/* Barra de filtros */}
      <div className="flex flex-row items-center justify-center bg-gray-100 mb-1 gap-8">

        <div className="flex flex-row text-xs text-gray-700 items-center justify-center gap-4">
          <span>Ordenamiento:</span>
          <select
            value={sorting}
            onChange={(e) => setSorting(e.target.value)}
            className="text-gray-700 hover:cursor-pointer text-xs bg-white border border-gray-300 rounded-lg shadow focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent py-[6px] pr-10"
          >
            <option value="">Orden de venta</option>
            <option value="desc">Descendente</option>
            <option value="asc">Ascendente</option>
          </select>
        </div>

        <div className="flex flex-row items-center justify-center gap-4">
          <span className="text-xs">Activos Agencia</span>
          <input
            type="checkbox"
            className="rounded-md border-gray-400 hover:cursor-pointer"
            checked={activeAgency}
            onChange={(e) => setActiveAgency(e.target.checked)}
          />
        </div>
            
      </div>

      {/* Body */}
      <div className="flex-grow overflow-y-auto">
        {loadingStatus ? (
            <div className="flex w-full h-full text-gray-700 items-center justify-center">
              <div className="flex w-full h-full text-xs gap-2 items-center justify-center">
                  <span>Cargando, por favor espera...</span>
                  <FaSpinner className="animate-spin text-gray-500" />
              </div>
            </div>
          ) : (
            clients.length === 0 ? (
              <div className="flex w-full h-full text-gray-700 items-center justify-center">
                <div className="flex w-full h-full text-xs gap-2 items-center justify-center">
                    <span>No hay registros</span>
                    <FaInfoCircle className="text-gray-500" />
                </div>
              </div>
              ) : (
              <table className="w-full text-xs">
                <thead className="bg-white sticky top-0">
                  <tr className="text-gray-700 text-center text-xs truncate uppercase font-bold">
                    {headersTableActive.filter((header)=>header.show===true).map((e) => (
                      <th
                        scope="col"
                        key={e.id}
                        className="px-2 py-3 text-center bg-[#FE6400] border-r border-r-white text-white border-red"
                      >
                        {e.name}
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {clients.map((e) => (
                    <ItemRowAfiliacionClientes
                      //setOpenModalServiciosCotizacionCliente={setOpenModalServiciosCotizacionCliente}
                      activeCols={headersTableActive}
                      //setOpenCotizacionesCliente={setOpenCotizacionesCliente}
                      //setCurrentClientCotizaciones={setCurrentClientCotizaciones}
                      //setCurrentClient={setCurrentClient}
                      setClients={setClients}
                      key={e.id}
                      client={e}
                    />
                  ))}
                </tbody>
              </table>
              )
            )
          }
      </div>
      
      {/* Paginador */}
      <div className="w-full flex flex-col gap-4 py-4 justify-center items-center">
        <span className="text-xs text-gray-700 dark:text-gray-500 ">
          Mostrando
          <span className="font-semibold text-gray-900 dark:text-gray-300 ">
            {" "}
            {clients.length}
          </span>{" "}
          de
          <span className="font-semibold text-gray-900 dark:text-gray-300 ">
            {" "}
            {totalDocs}
          </span>{" "}
          Clientes
        </span>

        <Pagination
          count={totalPages}
          page={page}
          variant="outlined" 
          shape="rounded"
          onChange={handlePageChange}
        />
      </div>
   
    </div>
  );
};

export default AfiliacionClientes;
